import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["size", "fixed", "bottom", "zIndex", "className", "style", "bgColor", "color", "position"];
import React from 'react';
import '@uiw/github-corners';
import { jsx as _jsx } from "react/jsx-runtime";
export default function githubCorners(props) {
  var {
      size = 80,
      fixed = false,
      bottom,
      zIndex,
      style,
      bgColor = '#151513',
      color = '#fff',
      position = 'right'
    } = props,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded);
  var styl = position === 'left' ? {
    left: 0,
    right: 'initial',
    transform: 'scale(-1, 1)'
  } : {
    right: 0,
    left: 'initial',
    transform: 'scale(1, 1)'
  };
  if (bottom) {
    styl.bottom = 0;
    styl.top = 'initial';
    styl.transform = position === 'left' ? 'scale(-1, -1)' : 'scale(1, -1)';
  } else {
    styl.bottom = 'initial';
    styl.top = 0;
  }
  return /*#__PURE__*/_jsx("github-corners", _extends({
    target: "__blank",
    width: size,
    height: size,
    href: props.href,
    position: fixed ? 'fixed' : 'absolute',
    "z-index": zIndex,
    style: style,
    fill: bgColor,
    color: color
  }, styl, otherProps));
}